<template>
  <div>
    <otp-data-table/>
  </div>
</template>

<script>
export default {
  data () {
    return {
      //
    }
  },
  components: {
    'otp-data-table': () => import("@/user/components/customer/OtpDataTable.vue")
  }
}
</script>

<style>

</style>